<script>
import PageHeader from '../../SettingsSubPageHeader.vue';
import Twilio from './Twilio.vue';
import ThreeSixtyDialogWhatsapp from './360DialogWhatsapp.vue';
import CloudWhatsapp from './CloudWhatsapp.vue';
import WhatsappEmbeddedSignup from './WhatsappEmbeddedSignup.vue';

export default {
  components: {
    PageHeader,
    Twilio,
    ThreeSixtyDialogWhatsapp,
    CloudWhatsapp,
    WhatsappEmbeddedSignup,
  },
  data() {
    return {
      provider: 'whatsapp_cloud',
    };
  },
  computed: {
    hasWhatsappAppId() {
      return (
        window.katalisConfig?.whatsappAppId &&
        window.katalisConfig.whatsappAppId !== 'none'
      );
    },
    availableProviders() {
      const providers = [
        {
          value: 'whatsapp_cloud',
          label: this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.WHATSAPP_CLOUD'),
        },
        {
          value: 'twilio',
          label: this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.TWILIO'),
        },
      ];
      return providers;
    },
    showEmbeddedSignup() {
      return false;
    },
    showManualSetup() {
      return (
        this.provider === 'whatsapp_cloud_manual' ||
        this.provider === 'whatsapp_cloud'
      );
    },
  },
  methods: {
    switchToManualSetup() {
      this.provider = 'whatsapp_cloud_manual';
    },
  },
};
</script>

<template>
  <div
    class="border border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0"
  >
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.WHATSAPP.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.WHATSAPP.DESC')"
    />
    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label>
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.LABEL') }}
        <select v-model="provider">
          <option
            v-for="providerOption in availableProviders"
            :key="providerOption.value"
            :value="providerOption.value"
          >
            {{ providerOption.label }}
          </option>
        </select>
      </label>
    </div>

    <!-- Show embedded signup if app ID is configured -->
    <div v-if="showEmbeddedSignup">
      <WhatsappEmbeddedSignup />
      <div class="pt-4 mt-4 border-t border-slate-100 dark:border-slate-700">
        <p class="text-sm text-slate-600 dark:text-slate-300">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.MANUAL_FALLBACK') }}
          <a
            href="#"
            class="text-woot-500 underline"
            @click.prevent="switchToManualSetup"
          >
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.EMBEDDED_SIGNUP.MANUAL_LINK_TEXT') }}
          </a>
        </p>
      </div>
    </div>

    <!-- Show manual setup -->
    <CloudWhatsapp v-else-if="showManualSetup" />

    <!-- Other providers -->
    <Twilio v-else-if="provider === 'twilio'" type="whatsapp" />
    <ThreeSixtyDialogWhatsapp v-else-if="provider === '360dialog'" />
    <CloudWhatsapp v-else />
  </div>
</template>
